import { Middleware } from '@nuxt/types';
/**
* This middleware is meant for the email confirm page.
*/
const emailResetMiddleware: Middleware = async ({ store, query, error, app, $cookies }) => {
  console.info('[emailResetMiddleware]');
  store.commit('SET_GLOBALSEARCH_DISPLAY', false);

  if (!query.token) return error({ statusCode: 404 });

  /*
    This try/catch prevents the template to be rendered if route doesn't contains
    a matching query to reset user's email
  */
  try {
    await store.$axios.post(`/accounts/email-reset/confirm/${query.token}?lang=${store.state.lang.locale}`);
  } catch (e) {
    const errorInstance: any = error;

    return errorInstance({
      statusCode: e.response.status,
      response: { data: { detail: e.response.data.detail } },
    });
  }
};

export default emailResetMiddleware;
